export class GlobalConstants {
  public static colors: string[] = [
    '#E6194B', // Rojo vivo
    '#3CB44B', // Verde brillante
    '#4363D8', // Azul intenso
    '#F58231', // Naranja llamativo
    '#911EB4', // Morado vibrante
    '#46F0F0', // Cian eléctrico
    '#F032E6', // Magenta vivo
    '#FABE28', // Amarillo fuerte
    '#008080', // Teal oscuro
    '#E6BEFF', // Lavanda brillante
    '#9A6324', // Marrón terroso
    '#FF9FAA', // Rosa claro
    '#1F77B4', // Azul suave
    '#FF7F0E', // Naranja intenso
    '#2CA02C', // Verde medio
    '#D62728', // Rojo ladrillo
    '#9467BD', // Morado apagado
    '#8C564B', // Marrón cálido
    '#E377C2', // Rosa medio
    '#7F7F7F', // Gris neutro
  ];
}
